import { useEffect, useMemo, useState } from 'react';
import apiClient from '../services/api';
import {
  getAdditionalSectionsFromContent,
  getBoxesFromContent,
  getBoxesSectionTitle,
} from '../utils/servicePageBody';

const hasValue = (value) => value !== undefined && value !== null && value !== '';

export default function useServicePageContent(slug, defaults = {}) {
  const [page, setPage] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const resp = await apiClient.getServicePage(slug);
        if (mounted && resp?.success) {
          setPage(resp.data || null);
        }
      } catch (e) {
        // Fall back to defaults when CMS record is missing.
      } finally {
        if (mounted) setLoaded(true);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [slug]);

  const content = useMemo(() => {
    const source = page || {};
    const sourceContent = source.content || {};

    const merged = {
      title: hasValue(source.title) ? source.title : defaults.title,
      subtitle: hasValue(source.subtitle) ? source.subtitle : defaults.subtitle,
      heroImageUrl: source.heroImageUrl || defaults.heroImageUrl,
      introTitle: hasValue(source.introTitle) ? source.introTitle : defaults.introTitle,
      introText: hasValue(source.introText) ? source.introText : defaults.introText,
      bodyHtml: sourceContent.bodyHtml || defaults.bodyHtml,
      sections: sourceContent.sections || defaults.sections,
      boxes: sourceContent.boxes,
      boxesSectionTitle: sourceContent.boxesSectionTitle,
    };

    return {
      ...merged,
      boxesSectionTitle: getBoxesSectionTitle(merged),
      boxes: getBoxesFromContent(merged),
      sections: getAdditionalSectionsFromContent(merged),
      loaded,
      fromDatabase: Boolean(page),
    };
  }, [defaults, loaded, page]);

  return { content, page, loaded };
}
